import React from "react";
import "./Footer.css";
import { useLanguage } from "../i18n/LanguageContext";
import LanguageSelector from "./LanguageSelector";
import logo from "../assets/logo_stradafacendo_cigliantours.png";

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src={logo} alt="StradaFacendo.club" />
      </div>
      <div className="footer-container">
        <div className="footer-section">
          <h3>{t("footer.offices")}</h3>
          <div className="office">
            <h4>CIGLIANO</h4>
            <p>C.so Umberto I, 101</p>
            <p>13043 Cigliano (VC)</p>
          </div>
          <div className="office">
            <h4>SANTHIÀ</h4>
            <p>Via Piave, 17</p>
            <p>13048 Santhià (VC)</p>
          </div>
          <div className="office">
            <h4>VERCELLI</h4>
            <p>C.so G. De Gregori, 34</p>
            <p>13100 Vercelli (VC)</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>{t("footer.hours")}</h3>
          <div className="hours-info">
            <p>
              <strong>CIGLIANO</strong>
            </p>
            <p>{t("footer.mondayFriday")}</p>
            <p>9:30 - 12:30</p>
            <p>15:30 - 18:30</p>
            <p>{t("footer.saturday")}</p>
            <p>9:00 - 12:00</p>
          </div>
          <div className="hours-info">
            <p>
              <strong>SANTHIÀ</strong>
            </p>
            <p>{t("footer.mondayFriday")}</p>
            <p>9:30 - 12:30</p>
            <p>15:30 - 18:30</p>
            <p>{t("footer.saturday")}</p>
            <p>9:00 - 12:00</p>
          </div>
          <div className="hours-info">
            <p>
              <strong>VERCELLI</strong>
            </p>
            <p>{t("footer.mondayFriday")}</p>
            <p>9:30 - 12:30</p>
            <p>15:30 - 18:30</p>
            <p>{t("footer.saturday")}</p>
            <p>9:00 - 12:00</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>{t("footer.contacts")}</h3>
          <div className="contact-info">
            <p>
              <strong>CIGLIANO</strong>
            </p>
            <p>Tel. +39 0161 433 433</p>
          </div>
          <div className="contact-info">
            <p>
              <strong>SANTHIÀ</strong>
            </p>
            <p>Tel. +39 375 604 1897</p>
            <p>
              <a
                href="https://wa.me/393756041897"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </p>
          </div>
          <div className="contact-info">
            <p>
              <strong>VERCELLI</strong>
            </p>
            <p>Tel. +39 340 775 4275</p>
            <p>
              <a
                href="https://wa.me/393407754275"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </p>
          </div>
          <div className="contact-email">
            <p>{t("footer.email")}:</p>
            <a href="mailto:info@stradafacendo.club">info@stradafacendo.club</a>
          </div>
        </div>

        <div className="footer-section">
          <h3>{t("footer.followUs")}</h3>
          <div className="social-links">
            <a
              href="https://www.facebook.com/stradafacendobycigliantours/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <span className="material-icons">facebook</span>
            </a>
            <a
              href="https://www.instagram.com/stradafacendobycigliantours/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
          <div className="footer-terms-cta">
            <a
              href="https://stradafacendo.club/uploads/CONDIZIONI_GENERALI.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="terms-button"
            >
              <span className="material-icons">description</span>
              {t("footer.termsAndConditions")}
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="company-info">
            <p>
              <strong>CIGLIANTOURS DI NO&VI S.n.c.</strong>
            </p>
            <p>C.so Umberto I, 101 - 13043 Cigliano (VC)</p>
            <p>Partita IVA: IT02756330029</p>
            <p>SDI: BA6ET11</p>
            <p>PEC: cigliantourssnc@pec.it</p>
          </div>
          <div className="footer-legal">
            <a
              href="https://www.iubenda.com/privacy-policy/62804605"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span className="separator">|</span>
            <a
              href="https://www.iubenda.com/privacy-policy/62804605/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cookie Policy
            </a>
          </div>
          <LanguageSelector variant="footer" />
          <p className="copyright">© 2026 Stradafacendo by Cigliantours</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
